import React from 'react';
import './Footer.scss';

function Footer() {
  return (
    <div className="footer d-flex justify-content-between align-items-center">
      <p className="mx-5"><b>ORION DATA VISUALIZATION</b></p>
      <p className="mx-5"><b>2022</b></p>
    </div>
  );
}

export default Footer;
